import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, FormCheck, Button, FormLabel, FormGroup } from 'react-bootstrap';
import { Buffer } from 'buffer';
// import { FMT_NUMBER, FMT_BYTES } from 'web3';
// import { toBigInt, toHex } from 'web3-utils';
import { useAccount, useSwitchChain } from 'wagmi';
import { useWeb3js, useWeb3jsSigner } from '../../web3/web3Client';
import { getContract, getContractAddress, getPriorityGasEstimate } from '../../web3/contractBuilder';
import { getOptInTokenStatus, getOptInSigningMsg, verifyOptIn } from '../../services/optin';
import { useGenesisBalance, useConfirm, usePending } from '../../hooks';
import { StakingContext } from '../../contexts/StakingContext';
import { genesis_Requirement, avgBlocksPerWeek, genesisChainId, pNFTChainId } from './constants';
import { three_decimals } from '../../helpers';
import { GenesisStatus } from './components/GenesisWidget';
// modals
import { ConfirmStake, ConfirmUnstake, ConfirmKYC, PendingStake, SuccessModal, PendingPairGenesis } from './Modals';

import './Stake.scss';



export function Stake() {
    const { address, status, chainId} = useAccount();
    const { chains, switchChain } = useSwitchChain();
    const [selectBsc, setSelectBsc] = useState(false);


    useEffect(() => {
        if(chainId === genesisChainId) {
            setSelectBsc(true)
        }

        if(chainId === pNFTChainId) {
            setSelectBsc(false)
        }
    }, [chainId])

    const handleNetworkChange = async (e) => {
        const target = e.target.checked ? genesisChainId : pNFTChainId;
        if(status == "connected" && address) {
            try {
                // TODO: check user network on first visit
                await switchChain({ chainId: target })
                // setSelectBsc(!(e.target.checked))
            } catch(e) {
                console.log(e)
            }
        }
    }

    return <Container>
        <section>
                <h1>Manage Your Publisher NFTs</h1>
                <h4>Deposit and lock your pNFT to starting earning rewards. pNFTs must be paired with Silver Notebook or Golden Backpack to begin staking.</h4>
                <h5>Select Publisher NFTs to Manage</h5>
                {/* <FormGroup style={{display: 'flex'}} id="network-switch">
                    <FormLabel>Polygon</FormLabel>
                    <FormCheck
                        type="switch" 
                        id="network-switch-ctrl" 
                        style={{marginLeft: '10px'}}
                        disabled={status == "connected" && !address}
                        checked={selectBsc}
                        onChange={handleNetworkChange}
                        />
                    <FormLabel>Binance Smart Chain</FormLabel>
                </FormGroup> */}
                <StakableList isBsc={selectBsc} />
        </section>
    </Container>
}


function StakableList(props) {
    const { address, status: ready, chainId} = useAccount();
    const { chains, switchChain } = useSwitchChain();

    const web3js = useWeb3jsSigner(chainId)
    const web3Reader = useWeb3js({ chainId: pNFTChainId});      // gas estimation
    const { genesis } = useGenesisBalance(address, ready == "connected");

    const { genesisPairing, status, fetching, fetched, metadata,
        stakable, stakedMapping, stakedPublishers, currEduPrice,
        dispatchGenesis
    } = useContext(StakingContext);

    const [ selectedTokenIds, setSelectedTokenIds ] = useState([]);
    const [ selectedGenesis, setSelectedGenesis ] = useState(false);

    const [ stakedTokens, setStakedTokens ] = useState([]); // staked pnft
    const [ unstakedTokens, setUnstakedTokens ] = useState([]); // not staked

    const [ allChecked, setAllChecked ] = useState(false);
    const [ isDepositMode, setIsDepositMode ] = useState(); // pnft deposit or withdraw
    const [ isPairingMode, setIsPairingMode ] = useState(); // genesis pairing or unpairing

    const [ isPending, setIsPending ] = useState(false);

    const [optInChecked, setOptInChecked] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    useEffect(() => {
        const sortTokens = async () => {
            // let metadata = await fetchMetadataJson();
            const stakedCol = stakedPublishers.map(x => x.publisher_nft_id)

            const st = [...stakedMapping.values()].map(x => {
                return {
                    ...x,
                    // ...metadata[x.publisher_nft_id],
                    rarity: metadata[x.publisher_nft_id].rarity,
                    id: metadata[x.publisher_nft_id].id,
                    isStaked: stakedCol.includes(x.publisher_nft_id),
                    isOwned: stakable.includes(x.publisher_nft_id) || stakedCol.includes(x.publisher_nft_id)
                }
            }).sort((a, b) => {
                if(a.isOwned && !b.isOwned) return 1;
                if(!a.isOwned && b.isOwned) return -1;
                if(a.isStaked && !b.isStaked) return 1;
                if(!a.isStaked && b.isStaked) return -1;
                if(a.points > b.points) return 1;
                if(a.points < b.points) return -1;
                if(a.rarity > b.rarity) return 1;
                if(a.rarity < b.rarity) return -1;

                return a.id - b.id;
            })

            setStakedTokens(st)
        }

        const sortStakable = async () => {
            // let metadata = await fetchMetadataJson();
            const stakedCol = [...stakedMapping.keys()];

            // filter out the ones with paired genesis
            // since they are included in the staked list
            const st = [...stakable].map(x => {
                return {
                    id: x,
                    rarity: metadata[x].rarity,
                    // ...metadata[x],
                    isOwned: true
                }
            }).filter(x => !stakedCol.includes(`${x.id}`))
            .sort((a, b) => {
                // if(a.points > b.points) return 1;
                // if(a.points < b.points) return -1;
                if(a.rarity > b.rarity) return 1;
                if(a.rarity < b.rarity) return -1;

                return a.id - b.id;
            })

            setUnstakedTokens(st)
        }

        if(fetched && stakedMapping?.size > 0 && Object.keys(metadata).length) {
            sortTokens();
        }

        if(fetched && stakable?.length > 0 && Object.keys(metadata).length) {
            sortStakable();
        }
    }, [stakedMapping, fetched, stakedPublishers, stakable, metadata])

    useEffect(() => {
        // check if the total selected genesis is greater than 0
        if(Object.keys(genesisPairing).length) {
            let count = 0;

            Object.values(genesisPairing).forEach(x => {
                count += x[0];
                count += x[1];
            })

            setSelectedGenesis(count > 0);
        }
    }, [genesisPairing])

    const toggleTokenSelection = (id, isStaked, genesisPaired) => {
        id = parseInt(id); // expect pnft id to be integers

        let newSelection;
        if(selectedTokenIds.indexOf(id) >= 0) {
            newSelection = selectedTokenIds.filter(x => x != id)
        } else {
            newSelection = [...selectedTokenIds, id]
        }

        
        setSelectedTokenIds(newSelection)
        if(newSelection.length == 0) {
            setIsDepositMode(null);
            setIsPairingMode(null);
        }  else {
            // pnft deposit/withdraw mode check
            setIsDepositMode(!isStaked);

            // genesis pairing mode check
            setIsPairingMode(!genesisPaired);
        }

    }

    const handleSelectAll = (e) => {
        setAllChecked(e.target.checked)

        if(e.target.checked) {
            // in polygon mode only select pnfts that are not staked
            // in genesis mode only select pnfts that are staked but not fully paired
            if(chainId === pNFTChainId) {
                setSelectedTokenIds(unstakedTokens.map(x => x.id))
            }

            // select all is always deposit mode
            setIsDepositMode(true);
        } else {
            setIsDepositMode();
            setSelectedTokenIds([])

            if(chainId === genesisChainId) {
                dispatchGenesis({ type: 'reset' })
            }

        }
    }

    const handleDepositGenesis = async () => {
        // need to handle safeTransferFrom and safeBatchTransferFrom
        // based on silver/golden numbers selected
        if(ready == "connected" && address && !isPending) {
            setIsPending(true)
            setErrMsg('')

            const genesisNFT = getContract("GenesisNFT", web3js);
            const to = getContractAddress("GenesisEscrow");
            const pnftAddress = getContractAddress("PublisherNFT");

            const confirm = await useConfirm(ConfirmStake, { data: selectedTokenIds, metadata, currEduPrice });
            if(!confirm) {
                setIsPending(false)
                return;
            }

            

            // check if any selected pnft has no genesis selected
            try {
                const pnft_no_pair = selectedTokenIds.filter(x => [...Object.keys(genesisPairing)].indexOf(`${x}`) < 0)
                if(pnft_no_pair.length > 0) {
                    throw new Error("Please ensure all selected pNFTs have genesis pairing or updated amount!")
                }

                // tally up total silver and golden
                const values = Object.values(genesisPairing).reduce((acc, x) => {
                    acc[0] += x[0];
                    acc[1] += x[1];
                    return acc;
                }, [0, 0])

                const goldenQuantities = Object.values(genesisPairing).map(x => x[0])
                const silverQuantities = Object.values(genesisPairing).map(x => x[1])

                if(genesis[0] < values[0] || genesis[1] < values[1]) {
                    throw new Error("You don't have enough genesis tokens!")
                }

                const inventories = new Array(selectedTokenIds.length).fill(pnftAddress)

                // encode
                // ['address[]', 'uint256[]', 'uint256[]', 'uint256[]'], 
                // [erc721Addresses, erc721TokenIds, erc1155TokenId1Quantities, erc1155TokenId2Quantities]
                // console.log(genesisPairing, goldenQuantities, silverQuantities)
                const data = web3Reader.eth.abi.encodeParameters(
                    ['address[]', 'uint256[]', 'uint256[]', 'uint256[]'],
                    [inventories, Object.keys(genesisPairing), goldenQuantities, silverQuantities]
                )

                // console.log(address, to, [1, 2], values, data)
                const tx = async () => {
                    return genesisNFT.methods['safeBatchTransferFrom'](address, to, [1, 2], values, data).send({
                        from: address,
                        maxPriorityFeePerGas: null, // needed for BNB
                        maxFeePerGas: null          // needed for BNB
                    })
                }

                const check = await usePending(PendingPairGenesis, tx, { data: values, title: "Adding Genesis Tokens", btn: "Confirm Add" })

                if(check?.status) {
                    useConfirm(SuccessModal, { msg: "You have successfully added Genesis tokens. Please note that it might take a while for the changes to be reflected." })
                }
            } catch(e) {
                console.error(e)
                setErrMsg(e.message)
            } finally {
                // setSelectedTokenIds([])
                setIsPending(false)
                setSelectedGenesis(false)
            }
        }
    }

    const handleWithdrawGenesis = async () => {
        if(ready == "connected" && address && !isPending) {
            setIsPending(true)
            setErrMsg('')
            
            const genesisEscrow = getContract("GenesisEscrow", web3js);
            const pnftAddress = getContractAddress("PublisherNFT");
            const inventories = new Array(selectedTokenIds.length).fill(pnftAddress);

            const confirm = await useConfirm(ConfirmUnstake, { data: selectedTokenIds })
            if(!confirm) {
                setIsPending(false)
                return;
            }

            // console.log(inventories, selectedTokenIds)

            try {
                const tx = () => {
                    return genesisEscrow.methods['withdraw'](inventories, selectedTokenIds).send({
                        from: address,
                        maxPriorityFeePerGas: null, // needed for BNB
                        maxFeePerGas: null          // needed for BNB
                    });
                }

                // const values = [0, 0];
                const values = [...stakedMapping.keys()].reduce((acc, x) => {
                    if(selectedTokenIds.indexOf(parseInt(x)) >= 0) {
                        acc[0] += parseInt(stakedMapping.get(x).golden);
                        acc[1] += parseInt(stakedMapping.get(x).silver);
                    }

                    return acc;
                }, [0, 0])

                if(values[0] == 0 && values[1] == 0) {
                    throw new Error("No Genesis tokens to Unstake")
                }

                const check = await usePending(PendingPairGenesis, tx, { data: values, title: "Removing Genesis Tokens", btn: "Confirm Remove" })

                if(check?.status) {
                    useConfirm(SuccessModal, { msg: "You have successfully removed Genesis tokens. Please note that it might take a while for the changes to be reflected." })
                }
            } catch(e) {
                console.error(e)
                setErrMsg(e.message)
            } finally {
                // setSelectedTokenIds([])
                setIsPending(false)
                setSelectedGenesis(false)
            }
        }
    }

    const handleApproval = async () => {
        if(ready == "connected" && address) {
            const pnft = getContract("PublisherNFT", web3js);
            const contractAddress = getContractAddress("PublisherNFTEscrow");

            const approved = await pnft.methods['isApprovedForAll'](address, contractAddress).call();
            if(approved) return;

            const maxPriorityFeePerGas = await getPriorityGasEstimate(web3Reader, 2);
            // const limit = await pnft.methods['setApprovalForAll'](contractAddress, true).estimateGas({
            //     from: address,
            //     number: FMT_NUMBER.HEX, 
            //     bytes: FMT_BYTES.HEX       
            // });
            // const gas = toHex(toBigInt(limit) * toBigInt(3) / toBigInt(2));

            return pnft.methods['setApprovalForAll'](contractAddress, true).send({
                from: address,
                // gas,
                maxPriorityFeePerGas,
                // maxFeePerGas: null 
            })
        }
    }

    const walletOptIn = async (address, tokens) => {
        const {walletAddress, timestamp, message, notOptedInTokens} = await getOptInSigningMsg(address, tokens)

        const msg = `0x${Buffer.from(message, "utf8").toString("hex")}`;
        const signature = await window.ethereum.request({
            method: "personal_sign",
            params: [msg, walletAddress],
        });

        if(signature) {
            const options = {
                tokenIds: notOptedInTokens,
                signedMessage: message,
                walletAddress,
                signature,
                timestamp
            };
            
            // console.log(options)
            await verifyOptIn(options)
        } else {
            throw new Error("User denied OptIn message signature request.")
        }
    }

    const handleDeposit = async () => {
        if(ready == "connected" && address && !isPending) {
            try {
                setIsPending(true)
                setErrMsg('')

                const pnftEscrow = getContract("PublisherNFTEscrow", web3js);
                const p_address = getContractAddress("PublisherNFT");

                const confirm = await useConfirm(ConfirmStake, { data: selectedTokenIds, metadata, currEduPrice });
                if(!confirm) {
                    setIsPending(false)
                    return;
                }

                // operator approval
                await handleApproval();

                // kyc warning
                if(!status) {
                    await useConfirm(ConfirmKYC, {});
                }
                
                if(!optInChecked) {
                    const OptInStatus = await getOptInTokenStatus(address, stakable);
                    const { notOptedInTokens } = OptInStatus;
                    
                    if(notOptedInTokens.length) {
                        const signed = await walletOptIn(address, notOptedInTokens)
                        if(signed) {
                            await verifyOptIn(signed)
                            setOptInChecked(true)
                        }
                    } else {
                        setOptInChecked(true)
                    }
                }

                const inventories = new Array(selectedTokenIds.length).fill(p_address);

                const maxPriorityFeePerGas = await getPriorityGasEstimate(web3Reader, 2);
                // const limit = await pnftEscrow.methods['deposit'](inventories, selectedTokenIds).estimateGas({
                //     from: account,
                //     number: FMT_NUMBER.HEX, 
                //     bytes: FMT_BYTES.HEX       
                // });
                // const gas = toHex(toBigInt(limit) * toBigInt(3) / toBigInt(2));

                const tx = async () => {
                    return pnftEscrow.methods['deposit'](inventories, selectedTokenIds).send({
                        from: address,
                        // gas,
                        maxPriorityFeePerGas,
                        // maxFeePerGas: null 
                    })
                }

                const check = await usePending(PendingStake, tx, { data: selectedTokenIds.length, title: "Stake Your pNFTs", btn: "Stake PNFTs" })

                if(check?.status) {
                    useConfirm(SuccessModal, {
                        next: () => { switchChain({ chainId: genesisChainId }) },
                        msg: "You have successfully staked your PNFTs. Please note that it might take a while for the changes to be reflected." 
                    })
                }
            } catch(e) {
                setErrMsg(e.message)
            } finally {
                setIsPending(false)
            }
        }
    }

    const handleWithdraw = async () => {
        if(ready == "connected" && address && !isPending) {
            try {
                setIsPending(true)
                setErrMsg('')

                const pnftEscrow = getContract("PublisherNFTEscrow", web3js);
                const p_address = getContractAddress("PublisherNFT");
                
                const confirm = await useConfirm(ConfirmUnstake, { data: selectedTokenIds })
                if(!confirm) {
                    setIsPending(false)
                    return;
                }
                
                const inventories = new Array(selectedTokenIds.length).fill(p_address)

                const maxPriorityFeePerGas = await getPriorityGasEstimate(web3Reader, 2);
                // const limit = await pnftEscrow.methods['withdraw'](inventories, selectedTokenIds).estimateGas({
                //     from: account,
                //     number: FMT_NUMBER.HEX, 
                //     bytes: FMT_BYTES.HEX
                // })

                // const gas = toHex(toBigInt(limit) * toBigInt(3) / toBigInt(2));
                
                const tx = async () => {
                    return pnftEscrow.methods['withdraw'](inventories, selectedTokenIds).send({
                        from: address,
                        // gas,
                        maxPriorityFeePerGas,
                        // maxFeePerGas: null   
                    })
                }

                const check = await usePending(PendingStake, tx, { data: selectedTokenIds.length, title: "Unstake Your pNFTs", btn: "Unstake PNFTs" })

                if(check?.status) {
                    useConfirm(SuccessModal, { 
                        next: () => { switchChain({ chainId: genesisChainId })},
                        msg: "You have successfully unstaked your PNFTs. Please note that it might take a while for the changes to be reflected." 
                    })
                }
            } catch(e) {
                console.error(e)
                setErrMsg(e.message)
            } finally {
                // setSelectedTokenIds([])
                setIsPending(false)
            }
        }
    }


    if(ready !== "connected" || !address) return <p>Please connect your wallet to view your publisher NFTs.</p>;

    if(address && fetching) return <p>...</p>

    if(fetched && !stakable.length && !stakedPublishers.length) return <p>You currently do not have any Publisher NFTs</p>

    return <div>
        <Container className='oc-data-table'>
            <Row className='table-header'>
                <Col lg={1} xs={1} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <FormCheck
                        type="checkbox" 
                        aria-label={'check-all'}
                        onChange={handleSelectAll} 
                        checked={allChecked}
                    />
                </Col>
                <Col lg={3} xs={11}>Item</Col>
                <Col lg={3} xs={12}>Genesis Pairing</Col>
                <Col lg={2} xs={6}>Status</Col>
                <Col lg={3} xs={6}>Est. Rewards per Week</Col>
            </Row>
            {stakedTokens.length > 0 && stakedTokens
                .map(x => { return {...x, id: x.publisher_nft_id}}) // potentially sort by stake timestamps
                .map(x => (
                    <PNFT {...x} {...props} key={x.id} 
                        allChecked={allChecked}
                        toggleCheckbox={toggleTokenSelection}
                        stakedMapping={stakedMapping} 
                        isDepositMode={isDepositMode} 
                        isPairingMode={isPairingMode}
                    />
                ))
            }
            {unstakedTokens.length > 0 && unstakedTokens.map(x => (
                <PNFT {...x} key={x.id} {...props}
                    allChecked={allChecked}
                    toggleCheckbox={toggleTokenSelection}
                    stakedMapping={stakedMapping} 
                    isDepositMode={isDepositMode} 
                    isPairingMode={isPairingMode}
                />
            ))}
        </Container>
        <div className="staking-action-panel">
            <div style={{color: '#EE1D1D', maxWidth: '50%'}}>{errMsg}</div>
            <div className='ctrls'>{
                (address && chainId === pNFTChainId) ? (
                    <>
                        <Button onClick={handleDeposit} variant='oc-primary' disabled={!selectedTokenIds.length || isDepositMode === false || isPending}>Stake Publisher</Button>
                        <Button onClick={handleWithdraw} variant='oc-primary' disabled={!selectedTokenIds.length || isDepositMode === true || isPending}>Unstake Publisher</Button>
                    </>
                ) : <></>
            }
            {
                (address && chainId === genesisChainId) ? (
                    <>
                        <Button onClick={handleDepositGenesis} variant='oc-primary' disabled={!selectedTokenIds.length || isPending || !selectedGenesis}>Stake Genesis</Button>
                        <Button onClick={handleWithdrawGenesis} variant='oc-primary' disabled={!selectedTokenIds.length || isPending}>Unstake Genesis</Button>
                    </>
                ) : <></>
            }
            {
                (address && chainId !== pNFTChainId && chainId !== genesisChainId) ? (
                    <>
                        <Button onClick={() => switchChain({ chainId: pNFTChainId })} variant='oc-primary'>Switch to Polygon</Button>
                    </>
                ) : <></>
            }</div>
        </div>
        <div style={{textAlign: 'end'}}>Priority Gas Fee Adjustment: +100% of Standard Estimates</div>
    </div>
}

function PNFT({ id, toggleCheckbox, allChecked, stakedMapping, isDepositMode, isPairingMode, isStaked, isOwned, isBsc }) {
    const { metadata, dispatchGenesis } = useContext(StakingContext)
    const [name, setName] = useState()
    const [nftId, setNftId] = useState()
    const [imgSrc, setImgSrc] = useState()
    const [rarity, setRarity] = useState()
    const [estReward, setEstReward] = useState()

    const [checked, setChecked] = useState(false)
    const [pairInfo, setPairInfo] = useState({ silver: 0, golden: 0})
    const [pairedPoints, setPairedPoints] = useState(0)
    const [pairedStatus, setPairedStatus] = useState(false)
    
    useEffect(() => {
        id = id.toString()
        if(metadata && metadata[id]) {
            const data = metadata[id]
            setName(data?.name)
            setNftId(data?.id)
            setImgSrc(data?.image)
            setRarity(data?.tier.toLowerCase())
            setEstReward(data?.yieldPerBlock * avgBlocksPerWeek)
        }
    }, [metadata, id])

    useEffect(() => {
        id = id + ""
        if(stakedMapping && stakedMapping.get(id)) {
            // there are paired genesis
            setPairInfo({
                golden: stakedMapping.get(id).golden,
                silver: stakedMapping.get(id).silver
            })

            setPairedPoints(stakedMapping.get(id).points)
        }
    }, [stakedMapping, id])

    useEffect(() => {
        if(!isNaN(pairedPoints) && rarity) {
            if(pairedPoints >= genesis_Requirement[rarity].points) {
                setPairedStatus(true)
            }
        }
    }, [pairedPoints, rarity])

    useEffect(() => {
        if(!allChecked) {
            setChecked(false)
        } else {
            // select all unstaked
            if(!isBsc && !isStaked) {
                setChecked(true)
            }
            
            // select all without enough genesis
            if(isBsc && rarity && pairedPoints < genesis_Requirement[rarity].points) {
                setChecked(true)
            }
        }
    }, [allChecked, isBsc, isStaked, rarity])

    const handleChecked = (e) => {
        let genesisPointsMet;
        if(isStaked) {
            const req = genesis_Requirement[rarity];
            genesisPointsMet = pairedPoints >= req.points;
        }

        setChecked(e.target.checked)
        toggleCheckbox(id, isStaked, genesisPointsMet)

        if(!e.target.checked) {   
            dispatchGenesis({ type: 'clear', pnft_id: id })
        }
    }
    

    return <Row>
        <Col lg={1} xs={1} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
            <FormCheck
                type="checkbox" 
                aria-label={id}
                onChange={handleChecked} 
                checked={checked}
                disabled={
                    (isStaked && isDepositMode === true) || 
                    (!isStaked && isDepositMode === false) ||
                    (isStaked && pairedStatus && isPairingMode === true) ||
                    (isStaked && !pairedStatus && isPairingMode === false) ||
                    (!isBsc && !isOwned)
                }
            />
        </Col> {/** checkbox */}
        <Col lg={3} xs={11}>
            <div className='pnft-item'>
                <div className='img-wrapper'>
                    <img src={imgSrc} width={60} />
                </div>
                <div>
                    <p className='emph'>{name} #{nftId}</p>
                    <p>{rarity}</p>
                </div>
            </div>
        </Col>
        <Col lg={3} xs={12}>
            <GenesisStatus 
                isStaked={isStaked} 
                id={id}
                checked={checked} 
                data={pairInfo} 
                rarity={rarity}
                pairedPoints={pairedPoints} 
                pairedStatus={pairedStatus}
                isDepositMode={isDepositMode}
                isBsc={isBsc}
            />
        </Col> {/** enabled by checkbox */}
        <Col lg={2} xs={6}>
            {!isOwned
            ? "Publisher No Longer Owned"
            : isStaked
                ? pairedPoints > 0
                    ? pairedStatus
                        ? "Staked"
                        : "Staked, Not Enough Genesis"
                    : "Staked, Genesis Not Paired"
                : pairedPoints > 0
                    ? "Not Staked"
                    : "Ready"
            }
        </Col>
        <Col lg={3} xs={6}>{isOwned ? `${three_decimals.format(estReward)} EDU` : '-'}</Col>
    </Row>
}
